import { render } from "./DougChart.vue?vue&type=template&id=4e3dccbb"
import script from "./DougChart.vue?vue&type=script&lang=js"
export * from "./DougChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__